import React from 'react'
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const demoSteps = [
    {
      text: (
        <div>
          Explore the conversation by clicking on <strong>dots</strong> or numbered circles. Each number reveals the pulse of voices waiting to be heard!
        </div>
      )
    },
    {
      text: (
        <div>
          Ready to join the movement?<br/>Click the <b>'Report'</b> button to sign up—it's a one-click ticket to amplify your voice!<br/>Click it again after you register, and you're ready to post!
        </div>
      )
    },
    {
      text: (
        <div>
          Every post is carefully screened to keep the dialogue respectful and dynamic. Once your post passes our filter, you'll get a notification—your voice is live!
        </div>
      )
    },
    {
      text: (
        <div>
          We don’t just listen; we act! We brainstorm solutions for your protest challenges and even connect with local officials to drive real change.
        </div>
      )
    },
    {
      text: (
        <div>
          Join the vibrant community—read and comment on posts from fellow changemakers, and let your insights spark further dialogue!
        </div>
      )
    }
  ];

function Demo(props) {
    const [demoStep, setDemoStep] = useState(0);

    return (
    props.isDemoPaneOpen && (
      <div class="fixed inset-0 flex justify-center">
        {/* Flex container with vertical stacking */}
        <div className="w-3/4 mx-auto demo bg-white rounded-lg shadow-lg">
          {/* Demo text */}
          <div className="text-sm text-center">
          <div className="dialog-close-button">
            <IconButton
              color="black"
              onClick={() => {
                setDemoStep(0);
                props.setIsDemoPaneOpen(false);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
            {demoSteps[demoStep].text}
          <div className="my-1">
            <span className="text-xs text-gray-500 ">Step {demoStep + 1} of {demoSteps.length}</span>
          </div>
          {/* Buttons in a row */}
          <div className="flex justify-center gap-2">

          {demoStep !== 0 && (
              <button
                disabled={demoStep === 0}
                className="bg-red-800 hover:bg-red-800 text-white font-bold py-1 px-2 rounded disabled:opacity-50"
                onClick={() => setDemoStep(prev => Math.max(prev - 1, 0))}
              >
                Previous
              </button>
          )}
            <button
              className="bg-green-800 hover:bg-green-900 text-white font-bold py-1 px-2 rounded"
              onClick={() => {
                if (demoStep < demoSteps.length - 1) {
                  setDemoStep(demoStep + 1);
                } else {
                  setDemoStep(0);
                  props.setIsDemoPaneOpen(false);
                }
              }}
            >
              {demoStep < demoSteps.length - 1 ? 'Next' : 'Finish'}
            </button>
          </div>
        </div>
        </div>
      </div>
    )
    );
}

export default Demo;
